import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "f958684c-1584-401f-bfa4-7861fca575c4"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterF958684c1584401fBfa47861fca575c4(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultFooterF958684c1584401fBfa47861fca575c4 footer`}>
      {props["links"] || <Navigation className="Links3b681887F25c42dfBd697f1b1b8b8773" parentTag={buildClassName("Links3b681887F25c42dfBd697f1b1b8b8773", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo33c5c09f626142a9A418497f1700bee7" parentTag={buildClassName("Logo33c5c09f626142a9A418497f1700bee7", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="CopyrightE5175a24813648dd8aa8176bc0bcc508" parentTag={buildClassName("CopyrightE5175a24813648dd8aa8176bc0bcc508", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow72a1d5b37d6d47efAfa1177af9727a12" parentTag={buildClassName("Groupflow72a1d5b37d6d47efAfa1177af9727a12", parentTag)} {...props} />}
    </div>
  );
}

// id: "1363d349-a044-4cc2-8f93-b36015673ddd"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "09ac3914-bb1b-4ab0-8f7a-0af507c4211d"
export function WelcomeBack1363d349A0444cc28f93B36015673ddd(props: any) {
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack1363d349A0444cc28f93B36015673ddd" parentTag={buildClassName("WelcomeBack1363d349A0444cc28f93B36015673ddd", parentTag)} {...props} />
  );
}

// id: "56188f64-475a-4397-91a8-b3f34ea2fe2f"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "ad61c8c8-5921-4796-a103-2a63e163a24c"
export function Navigation56188f64475a439791a8B3f34ea2fe2f(props: any) {
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation56188f64475a439791a8B3f34ea2fe2f" parentTag={buildClassName("Navigation56188f64475a439791a8B3f34ea2fe2f", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "27fcd17b-e46b-4408-86e1-5b3749d20701"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "ad61c8c8-5921-4796-a103-2a63e163a24c"
export function LinkedLogo27fcd17bE46b440886e15b3749d20701(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo27fcd17bE46b440886e15b3749d20701" parentTag={buildClassName("LinkedLogo27fcd17bE46b440886e15b3749d20701", parentTag)} url="/" className="linked-logo" label={<Logo className="LabelE34436db143e46f5A1ed7eb0a157b7ae" parentTag={buildClassName("LabelE34436db143e46f5A1ed7eb0a157b7ae", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} {...props} />
  );
}

// id: "0b4acca3-fdbf-4e1d-a730-4d9d6d15e54e"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "89b70a46-d855-4ee8-9e9c-ce21a149cb94"
export function HeaderTop0b4acca3Fdbf4e1dA7304d9d6d15e54e(props: any) {
  return (
    <DefaultHeaderTopAd61c8c859214796A1032a63e163a24c parentTag="HeaderTop0b4acca3Fdbf4e1dA7304d9d6d15e54e" {...props} />
  );
}

// id: "1e65ce4d-64a1-4191-bc32-9e838b9e321d"
// title: ""
// type: :text
// key: "class"
// parent_id: "56188f64-475a-4397-91a8-b3f34ea2fe2f"
export const Class1e65ce4d64a14191Bc329e838b9e321d = "navigation";

// id: "11346f21-cfad-4a85-81bd-19d8fa6e6247"
// title: ""
// type: :gf_preset
// key: "hero"
// parent_id: "3532a69f-06c9-4348-a3bf-81741d63f28e"
export function Hero11346f21Cfad4a8581bd19d8fa6e6247(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Hero className="Hero11346f21Cfad4a8581bd19d8fa6e6247" parentTag={buildClassName("Hero11346f21Cfad4a8581bd19d8fa6e6247", parentTag)} postSlug="home-hero" {...props} />
  );
}

// id: "ad61c8c8-5921-4796-a103-2a63e163a24c"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopAd61c8c859214796A1032a63e163a24c(props: any) {
  const Link = AppStore.presets["Link"];
  const Logo = AppStore.presets["Logo"];
  const PrimaryNavigation = AppStore.presets["PrimaryNavigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopAd61c8c859214796A1032a63e163a24c header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo27fcd17bE46b440886e15b3749d20701" parentTag={buildClassName("LinkedLogo27fcd17bE46b440886e15b3749d20701", parentTag)} url="/" className="linked-logo" label={<Logo className="LabelE34436db143e46f5A1ed7eb0a157b7ae" parentTag={buildClassName("LabelE34436db143e46f5A1ed7eb0a157b7ae", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />} {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation56188f64475a439791a8B3f34ea2fe2f" parentTag={buildClassName("Navigation56188f64475a439791a8B3f34ea2fe2f", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "72a1d5b3-7d6d-47ef-afa1-177af9727a12"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "f958684c-1584-401f-bfa4-7861fca575c4"
export function Groupflow72a1d5b37d6d47efAfa1177af9727a12(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow72a1d5b37d6d47efAfa1177af9727a12" parentTag={buildClassName("Groupflow72a1d5b37d6d47efAfa1177af9727a12", parentTag)} {...props} />
  );
}

// id: "e5175a24-8136-48dd-8aa8-176bc0bcc508"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "f958684c-1584-401f-bfa4-7861fca575c4"
export function CopyrightE5175a24813648dd8aa8176bc0bcc508(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightE5175a24813648dd8aa8176bc0bcc508" parentTag={buildClassName("CopyrightE5175a24813648dd8aa8176bc0bcc508", parentTag)} {...props} />
  );
}

// id: "3b681887-f25c-42df-bd69-7f1b1b8b8773"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "f958684c-1584-401f-bfa4-7861fca575c4"
export function Links3b681887F25c42dfBd697f1b1b8b8773(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links3b681887F25c42dfBd697f1b1b8b8773" parentTag={buildClassName("Links3b681887F25c42dfBd697f1b1b8b8773", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "a284d4ca-828c-43f5-aa1f-eccf5288f9ab"
// title: ""
// type: :text
// key: "title"
// parent_id: "02899031-ba6b-484a-a014-1ccdef7ad44a"
export const TitleA284d4ca828c43f5Aa1fEccf5288f9ab = "About Us";

// id: "c28a30ae-89f1-44c2-af80-4936a14b3dce"
// title: ""
// type: :text
// key: "url"
// parent_id: "27fcd17b-e46b-4408-86e1-5b3749d20701"
export const UrlC28a30ae89f144c2Af804936a14b3dce = "/";

// id: "ef0f18bc-6f6c-4374-b928-49250c22441b"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopAd61c8c859214796A1032a63e163a24c parentTag="HeaderTop9a9fe0813ffe479f9ca14d92bcd675e3" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero050d9c08780e4738A0f7Ea45420b5f5d parentTag="Hero2e54bb8a966047a2B0dc091dfdd73333" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "2e54bb8a-9660-47a2-b0dc-091dfdd73333"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "ef0f18bc-6f6c-4374-b928-49250c22441b"
export function Hero2e54bb8a966047a2B0dc091dfdd73333(props: any) {
  return (
    <SecondaryMarketingHero050d9c08780e4738A0f7Ea45420b5f5d parentTag="Hero2e54bb8a966047a2B0dc091dfdd73333" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "c1655673-e003-45ba-8d23-7332849dd6d1"
// title: ""
// type: :text
// key: "title"
// parent_id: "050d9c08-780e-4738-a0f7-ea45420b5f5d"
export const TitleC1655673E00345ba8d237332849dd6d1 = "Default Title";

// id: "05d8ef84-6919-4be9-858b-bbaaf378627f"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "f9986a18-154c-4504-b418-b85b7f8a7658"
export const LogoType05d8ef8469194be9858bBbaaf378627f = "DEFAULT";

// id: "7e759bda-4f68-410a-9da1-200f9aea8707"
// title: ""
// type: :text
// key: "class"
// parent_id: "27fcd17b-e46b-4408-86e1-5b3749d20701"
export const Class7e759bda4f68410a9da1200f9aea8707 = "linked-logo";

// id: "0edd4b2f-7609-4711-9c33-ab13718a2041"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "e34436db-143e-46f5-a1ed-7eb0a157b7ae"
export const LogoType0edd4b2f760947119c33Ab13718a2041 = "DEFAULT";

// id: "d5342540-ccf5-469a-bebc-fa53ef18815f"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPageD5342540Ccf5469aBebcFa53ef18815f(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPageD5342540Ccf5469aBebcFa53ef18815f gf-page-layout`}>
      {props["header"] || <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="Header02899031Ba6b484aA0141ccdef7ad44a" title="About Us" {...props} />}
      {props["main"] || <Main92fa63429fce4bf08d9c98a7024d3bce />}
      {props["footer"] || <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="Footer610203e556e94dd48fc74f100f875536" {...props} />}
    </div>
  );
}

// id: "f9986a18-154c-4504-b418-b85b7f8a7658"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "ad61c8c8-5921-4796-a103-2a63e163a24c"
export function LogoF9986a18154c4504B418B85b7f8a7658(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LogoF9986a18154c4504B418B85b7f8a7658" parentTag={buildClassName("LogoF9986a18154c4504B418B85b7f8a7658", parentTag)} logoType="DEFAULT" {...props} />
  );
}

// id: "f8249565-765e-4874-a330-610a569fd211"
// title: ""
// type: :reference
// key: "header"
// parent_id: "7ef85935-983a-4822-89d4-3603fc712fda"
export function HeaderF8249565765e4874A330610a569fd211(props: any) {
  return (
    <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="HeaderF8249565765e4874A330610a569fd211" title="Join Us" {...props} />
  );
}

// id: "35bb69ff-2335-4667-aa25-b91a68863747"
// title: ""
// type: :reference
// key: "header"
// parent_id: "374b7782-fb61-4eba-861c-73dc039a1989"
export function Header35bb69ff23354667Aa25B91a68863747(props: any) {
  return (
    <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="Header35bb69ff23354667Aa25B91a68863747" title="Secondary Page" {...props} />
  );
}

// id: "e7b6a80c-26e5-4e3c-bf99-30e9003a44e8"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "33c5c09f-6261-42a9-a418-497f1700bee7"
export const LogoTypeE7b6a80c26e54e3cBf9930e9003a44e8 = "FOOTER";

// id: "601a7be6-d299-4be5-a1c0-1146e8161ee4"
// title: "Home Cards"
// type: :gf_preset
// key: "cards"
// parent_id: "1fdb5824-7b21-473a-94ed-31d99ed8bffd"
export function Cards601a7be6D2994be5A1c01146e8161ee4(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards601a7be6D2994be5A1c01146e8161ee4" parentTag={buildClassName("Cards601a7be6D2994be5A1c01146e8161ee4", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />
  );
}

// id: "38c6ce3a-8220-469f-bac6-c81184ddcdc3"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "11346f21-cfad-4a85-81bd-19d8fa6e6247"
export const PostSlug38c6ce3a8220469fBac6C81184ddcdc3 = "home-hero";

// id: "6ffca564-a0a4-4356-b331-ada13f7a9cc1"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPage6ffca564A0a44356B331Ada13f7a9cc1(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPage6ffca564A0a44356B331Ada13f7a9cc1`}>
      {props["header"] || <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="HeaderC66c7967E6e3486691e06e039537d8bf" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="FooterA94f8376E11e46a2979dBcf2f47c4626" {...props} />}
    </div>
  );
}

// id: "92fa6342-9fce-4bf0-8d9c-98a7024d3bce"
// title: ""
// type: :html
// key: "main"
// parent_id: "d5342540-ccf5-469a-bebc-fa53ef18815f"
export function Main92fa63429fce4bf08d9c98a7024d3bce(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main92fa63429fce4bf08d9c98a7024d3bce`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards2ff36d231cfd4361Bb5e36919a785a65" parentTag={buildClassName("Cards2ff36d231cfd4361Bb5e36919a785a65", parentTag)} postSlug="about-us-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "d7fa9b74-1945-4251-b4f9-74d6febf4056"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "09ac3914-bb1b-4ab0-8f7a-0af507c4211d"
export function QuoteD7fa9b7419454251B4f974d6febf4056(props: any) {
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteD7fa9b7419454251B4f974d6febf4056" parentTag={buildClassName("QuoteD7fa9b7419454251B4f974d6febf4056", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "1fdb5824-7b21-473a-94ed-31d99ed8bffd"
// title: "Home Main"
// type: :html
// key: "main"
// parent_id: "09ac3914-bb1b-4ab0-8f7a-0af507c4211d"
export function Main1fdb58247b21473a94ed31d99ed8bffd(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <main className={`${parentTag || ""} Main1fdb58247b21473a94ed31d99ed8bffd`}>
      <div className="cards-wrapper">
        {props["cards"] || <MarketingCards className="Cards601a7be6D2994be5A1c01146e8161ee4" parentTag={buildClassName("Cards601a7be6D2994be5A1c01146e8161ee4", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-cards" {...props} />}
      </div>
    </main>
  );
}

// id: "b390eeb9-0533-4bd5-aeaa-329edd2501a4"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "56188f64-475a-4397-91a8-b3f34ea2fe2f"
export const NavMenuSlugB390eeb905334bd5Aeaa329edd2501a4 = "marketing-primary-nav";

// id: "3532a69f-06c9-4348-a3bf-81741d63f28e"
// title: ""
// type: :html
// key: "hero-wrapper"
// parent_id: "89b70a46-d855-4ee8-9e9c-ce21a149cb94"
export function HeroWrapper3532a69f06c94348A3bf81741d63f28e(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeroWrapper3532a69f06c94348A3bf81741d63f28e`}>
      {props["hero"] || <Hero className="Hero11346f21Cfad4a8581bd19d8fa6e6247" parentTag={buildClassName("Hero11346f21Cfad4a8581bd19d8fa6e6247", parentTag)} postSlug="home-hero" {...props} />}
    </div>
  );
}

// id: "7ef85935-983a-4822-89d4-3603fc712fda"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPage7ef85935983a482289d43603fc712fda(props: any) {
  return (
    <SecondaryPage374b7782Fb614eba861c73dc039a1989 parentTag="JoinUsPage7ef85935983a482289d43603fc712fda" header={<SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="HeaderF8249565765e4874A330610a569fd211" title="Join Us" />} {...props} />
  );
}

// id: "02899031-ba6b-484a-a014-1ccdef7ad44a"
// title: ""
// type: :reference
// key: "header"
// parent_id: "d5342540-ccf5-469a-bebc-fa53ef18815f"
export function Header02899031Ba6b484aA0141ccdef7ad44a(props: any) {
  return (
    <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="Header02899031Ba6b484aA0141ccdef7ad44a" title="About Us" {...props} />
  );
}

// id: "89b70a46-d855-4ee8-9e9c-ce21a149cb94"
// title: "Home Header Wrapper"
// type: :html
// key: "header-wrapper"
// parent_id: "09ac3914-bb1b-4ab0-8f7a-0af507c4211d"
export function HeaderWrapper89b70a46D8554ee89e9cCe21a149cb94(props: any) {
  const Hero = AppStore.presets["Hero"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HeaderWrapper89b70a46D8554ee89e9cCe21a149cb94`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopAd61c8c859214796A1032a63e163a24c parentTag="HeaderTop0b4acca3Fdbf4e1dA7304d9d6d15e54e" {...props} />}
      </div>
      {props["hero-wrapper"] || <HeroWrapper3532a69f06c94348A3bf81741d63f28e />}
    </div>
  );
}

// id: "610203e5-56e9-4dd4-8fc7-4f100f875536"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "d5342540-ccf5-469a-bebc-fa53ef18815f"
export function Footer610203e556e94dd48fc74f100f875536(props: any) {
  return (
    <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="Footer610203e556e94dd48fc74f100f875536" {...props} />
  );
}

// id: "ce4e5cb7-0b37-480f-a905-ac30b9671c9e"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "33c5c09f-6261-42a9-a418-497f1700bee7"
export const ContentSlugCe4e5cb70b37480fA905Ac30b9671c9e = "footer-logo";

// id: "faa81e06-9318-4ef4-b6d4-b903e2c49868"
// title: ""
// type: :text
// key: "title"
// parent_id: "f8249565-765e-4874-a330-610a569fd211"
export const TitleFaa81e0693184ef4B6d4B903e2c49868 = "Join Us";

// id: "91249ff3-b230-4304-9471-a26354174682"
// title: "Member Application Pages"
// type: :reference
// key: "application-pages"
// parent_id: nil
export function ApplicationPages91249ff3B23043049471A26354174682(props: any) {
  return (
    <SecondaryPage374b7782Fb614eba861c73dc039a1989 parentTag="ApplicationPages91249ff3B23043049471A26354174682" header={<SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="Header9dff01b47f4841b1A4c0C717597ed6c0" title="Join Us" />} {...props} />
  );
}

// id: "9a9fe081-3ffe-479f-9ca1-4d92bcd675e3"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "ef0f18bc-6f6c-4374-b928-49250c22441b"
export function HeaderTop9a9fe0813ffe479f9ca14d92bcd675e3(props: any) {
  return (
    <DefaultHeaderTopAd61c8c859214796A1032a63e163a24c parentTag="HeaderTop9a9fe0813ffe479f9ca14d92bcd675e3" {...props} />
  );
}

// id: "c66c7967-e6e3-4866-91e0-6e039537d8bf"
// title: ""
// type: :reference
// key: "header"
// parent_id: "6ffca564-a0a4-4356-b331-ada13f7a9cc1"
export function HeaderC66c7967E6e3486691e06e039537d8bf(props: any) {
  return (
    <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="HeaderC66c7967E6e3486691e06e039537d8bf" title="Public Events" {...props} />
  );
}

// id: "2ff36d23-1cfd-4361-bb5e-36919a785a65"
// title: ""
// type: :gf_preset
// key: "cards"
// parent_id: "92fa6342-9fce-4bf0-8d9c-98a7024d3bce"
export function Cards2ff36d231cfd4361Bb5e36919a785a65(props: any) {
  const MarketingCards = AppStore.presets["MarketingCards"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="Cards2ff36d231cfd4361Bb5e36919a785a65" parentTag={buildClassName("Cards2ff36d231cfd4361Bb5e36919a785a65", parentTag)} postSlug="about-us-cards" {...props} />
  );
}

// id: "63918a90-1852-46ed-abca-5c504cc4a866"
// title: ""
// type: :text
// key: "title"
// parent_id: "35bb69ff-2335-4667-aa25-b91a68863747"
export const Title63918a90185246edAbca5c504cc4a866 = "Secondary Page";

// id: "d3430853-b8c3-483d-bab4-17e1d5b4373f"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "2ff36d23-1cfd-4361-bb5e-36919a785a65"
export const PostSlugD3430853B8c3483dBab417e1d5b4373f = "about-us-cards";

// id: "374b7782-fb61-4eba-861c-73dc039a1989"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage374b7782Fb614eba861c73dc039a1989(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage374b7782Fb614eba861c73dc039a1989`}>
      {props["header"] || <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="Header35bb69ff23354667Aa25B91a68863747" title="Secondary Page" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="FooterC0d7f05f8a12492eAefb43f794b76c08" {...props} />}
    </div>
  );
}

// id: "9dff01b4-7f48-41b1-a4c0-c717597ed6c0"
// title: ""
// type: :reference
// key: "header"
// parent_id: "91249ff3-b230-4304-9471-a26354174682"
export function Header9dff01b47f4841b1A4c0C717597ed6c0(props: any) {
  return (
    <SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b parentTag="Header9dff01b47f4841b1A4c0C717597ed6c0" title="Join Us" {...props} />
  );
}

// id: "e9a79ffd-2763-4cc8-976b-9b6bf5b4dfab"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "09ac3914-bb1b-4ab0-8f7a-0af507c4211d"
export function FooterE9a79ffd27634cc8976b9b6bf5b4dfab(props: any) {
  return (
    <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="FooterE9a79ffd27634cc8976b9b6bf5b4dfab" {...props} />
  );
}

// id: "94e1ccce-2bbf-403a-8787-01f41dba9c4b"
// title: ""
// type: :text
// key: "title"
// parent_id: "9dff01b4-7f48-41b1-a4c0-c717597ed6c0"
export const Title94e1ccce2bbf403a878701f41dba9c4b = "Join Us";

// id: "eb89bf8f-3516-4fc1-a838-f4417c62ed7b"
// title: ""
// type: :text
// key: "title"
// parent_id: "2e54bb8a-9660-47a2-b0dc-091dfdd73333"
export const TitleEb89bf8f35164fc1A838F4417c62ed7b = "Secondary Marketing Title 2";

// id: "c0497c79-2589-4d83-ad28-ba1c50a3c26f"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "e34436db-143e-46f5-a1ed-7eb0a157b7ae"
export const ContentSlugC0497c7925894d83Ad28Ba1c50a3c26f = "header-logo";

// id: "050d9c08-780e-4738-a0f7-ea45420b5f5d"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero050d9c08780e4738A0f7Ea45420b5f5d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero050d9c08780e4738A0f7Ea45420b5f5d hero`}>
      <h1 className="title">
        {props["title"] || TitleC1655673E00345ba8d237332849dd6d1}
      </h1>
    </div>
  );
}

// id: "c0d7f05f-8a12-492e-aefb-43f794b76c08"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "374b7782-fb61-4eba-861c-73dc039a1989"
export function FooterC0d7f05f8a12492eAefb43f794b76c08(props: any) {
  return (
    <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="FooterC0d7f05f8a12492eAefb43f794b76c08" {...props} />
  );
}

// id: "a94f8376-e11e-46a2-979d-bcf2f47c4626"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "6ffca564-a0a4-4356-b331-ada13f7a9cc1"
export function FooterA94f8376E11e46a2979dBcf2f47c4626(props: any) {
  return (
    <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="FooterA94f8376E11e46a2979dBcf2f47c4626" {...props} />
  );
}

// id: "8ec6b5b2-cd76-4bca-9e3e-01895927927f"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "d7fa9b74-1945-4251-b4f9-74d6febf4056"
export const ContentSlug8ec6b5b2Cd764bca9e3e01895927927f = "home-page-quote";

// id: "e34436db-143e-46f5-a1ed-7eb0a157b7ae"
// title: "Home Page Logo"
// type: :gf_preset
// key: "label"
// parent_id: "27fcd17b-e46b-4408-86e1-5b3749d20701"
export function LabelE34436db143e46f5A1ed7eb0a157b7ae(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="LabelE34436db143e46f5A1ed7eb0a157b7ae" parentTag={buildClassName("LabelE34436db143e46f5A1ed7eb0a157b7ae", parentTag)} logoType="DEFAULT" contentSlug="header-logo" {...props} />
  );
}

// id: "af2c193c-3d38-42f2-8f35-42963ffe3233"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "601a7be6-d299-4be5-a1c0-1146e8161ee4"
export const ButtonClassAf2c193c3d3842f28f3542963ffe3233 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "09ac3914-bb1b-4ab0-8f7a-0af507c4211d"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePage09ac3914Bb1b4ab08f7a0af507c4211d(props: any) {
  const Header = AppStore.presets["Header"];
  const WelcomeBackPopUp = AppStore.presets["WelcomeBackPopUp"];
  const MarketingCards = AppStore.presets["MarketingCards"];
  const PageQuote = AppStore.presets["PageQuote"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePage09ac3914Bb1b4ab08f7a0af507c4211d gf-page-layout`}>
      {props["header-wrapper"] || <HeaderWrapper89b70a46D8554ee89e9cCe21a149cb94 />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack1363d349A0444cc28f93B36015673ddd" parentTag={buildClassName("WelcomeBack1363d349A0444cc28f93B36015673ddd", parentTag)} {...props} />}
      {props["main"] || <Main1fdb58247b21473a94ed31d99ed8bffd />}
      {props["quote"] || <PageQuote className="QuoteD7fa9b7419454251B4f974d6febf4056" parentTag={buildClassName("QuoteD7fa9b7419454251B4f974d6febf4056", parentTag)} contentSlug="home-page-quote" {...props} />}
      {props["footer"] || <DefaultFooterF958684c1584401fBfa47861fca575c4 parentTag="FooterE9a79ffd27634cc8976b9b6bf5b4dfab" {...props} />}
    </div>
  );
}

// id: "33c5c09f-6261-42a9-a418-497f1700bee7"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "f958684c-1584-401f-bfa4-7861fca575c4"
export function Logo33c5c09f626142a9A418497f1700bee7(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo33c5c09f626142a9A418497f1700bee7" parentTag={buildClassName("Logo33c5c09f626142a9A418497f1700bee7", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "8da51199-15c0-485d-9f86-f1eea8620b21"
// title: ""
// type: :text
// key: "title"
// parent_id: "ef0f18bc-6f6c-4374-b928-49250c22441b"
export const Title8da5119915c0485d9f86F1eea8620b21 = "Secondary Marketing Title 1";

// id: "4d725412-63e2-46b8-b395-29e38a0a4698"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "3b681887-f25c-42df-bd69-7f1b1b8b8773"
export const NavMenuSlug4d72541263e246b8B39529e38a0a4698 = "footer-nav";

// id: "75f28626-9ba4-43d5-8792-3905df8d8465"
// title: ""
// type: :text
// key: "title"
// parent_id: "c66c7967-e6e3-4866-91e0-6e039537d8bf"
export const Title75f286269ba443d587923905df8d8465 = "Public Events";

// id: "75d727e7-3a04-4b65-9010-5848a854e581"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "601a7be6-d299-4be5-a1c0-1146e8161ee4"
export const PostSlug75d727e73a044b6590105848a854e581 = "home-page-cards";

const Components = {
  DefaultFooterF958684c1584401fBfa47861fca575c4,
  WelcomeBack1363d349A0444cc28f93B36015673ddd,
  Navigation56188f64475a439791a8B3f34ea2fe2f,
  LinkedLogo27fcd17bE46b440886e15b3749d20701,
  HeaderTop0b4acca3Fdbf4e1dA7304d9d6d15e54e,
  Class1e65ce4d64a14191Bc329e838b9e321d,
  Hero11346f21Cfad4a8581bd19d8fa6e6247,
  DefaultHeaderTopAd61c8c859214796A1032a63e163a24c,
  Groupflow72a1d5b37d6d47efAfa1177af9727a12,
  CopyrightE5175a24813648dd8aa8176bc0bcc508,
  Links3b681887F25c42dfBd697f1b1b8b8773,
  TitleA284d4ca828c43f5Aa1fEccf5288f9ab,
  UrlC28a30ae89f144c2Af804936a14b3dce,
  SecondaryMarketingHeaderEf0f18bc6f6c4374B92849250c22441b,
  Hero2e54bb8a966047a2B0dc091dfdd73333,
  TitleC1655673E00345ba8d237332849dd6d1,
  LogoType05d8ef8469194be9858bBbaaf378627f,
  Class7e759bda4f68410a9da1200f9aea8707,
  LogoType0edd4b2f760947119c33Ab13718a2041,
  AboutUsPageD5342540Ccf5469aBebcFa53ef18815f,
  LogoF9986a18154c4504B418B85b7f8a7658,
  HeaderF8249565765e4874A330610a569fd211,
  Header35bb69ff23354667Aa25B91a68863747,
  LogoTypeE7b6a80c26e54e3cBf9930e9003a44e8,
  Cards601a7be6D2994be5A1c01146e8161ee4,
  PostSlug38c6ce3a8220469fBac6C81184ddcdc3,
  PublicEventsPage6ffca564A0a44356B331Ada13f7a9cc1,
  Main92fa63429fce4bf08d9c98a7024d3bce,
  QuoteD7fa9b7419454251B4f974d6febf4056,
  Main1fdb58247b21473a94ed31d99ed8bffd,
  NavMenuSlugB390eeb905334bd5Aeaa329edd2501a4,
  HeroWrapper3532a69f06c94348A3bf81741d63f28e,
  JoinUsPage7ef85935983a482289d43603fc712fda,
  Header02899031Ba6b484aA0141ccdef7ad44a,
  HeaderWrapper89b70a46D8554ee89e9cCe21a149cb94,
  Footer610203e556e94dd48fc74f100f875536,
  ContentSlugCe4e5cb70b37480fA905Ac30b9671c9e,
  TitleFaa81e0693184ef4B6d4B903e2c49868,
  ApplicationPages91249ff3B23043049471A26354174682,
  HeaderTop9a9fe0813ffe479f9ca14d92bcd675e3,
  HeaderC66c7967E6e3486691e06e039537d8bf,
  Cards2ff36d231cfd4361Bb5e36919a785a65,
  Title63918a90185246edAbca5c504cc4a866,
  PostSlugD3430853B8c3483dBab417e1d5b4373f,
  SecondaryPage374b7782Fb614eba861c73dc039a1989,
  Header9dff01b47f4841b1A4c0C717597ed6c0,
  FooterE9a79ffd27634cc8976b9b6bf5b4dfab,
  Title94e1ccce2bbf403a878701f41dba9c4b,
  TitleEb89bf8f35164fc1A838F4417c62ed7b,
  ContentSlugC0497c7925894d83Ad28Ba1c50a3c26f,
  SecondaryMarketingHero050d9c08780e4738A0f7Ea45420b5f5d,
  FooterC0d7f05f8a12492eAefb43f794b76c08,
  FooterA94f8376E11e46a2979dBcf2f47c4626,
  ContentSlug8ec6b5b2Cd764bca9e3e01895927927f,
  LabelE34436db143e46f5A1ed7eb0a157b7ae,
  ButtonClassAf2c193c3d3842f28f3542963ffe3233,
  HomePage09ac3914Bb1b4ab08f7a0af507c4211d,
  Logo33c5c09f626142a9A418497f1700bee7,
  Title8da5119915c0485d9f86F1eea8620b21,
  NavMenuSlug4d72541263e246b8B39529e38a0a4698,
  Title75f286269ba443d587923905df8d8465,
  PostSlug75d727e73a044b6590105848a854e581
}

export default Components;